define('app/models/FieldFilter',['require','glu/model','app/config/filterTypes','glu/util','glu/http'],function(require) {
	'use strict';

	var Model = require('glu/model'),
		FILTER_TYPES = require('app/config/filterTypes'),
		_ = require('glu/util'),
		http = require('glu/http');


	var VALID_OPERATORS = _.pluck(FILTER_TYPES.field, 'operator');
	var FIELD_CONSTRAINTS_SERVICE_URL = '/analytics/rest/service/fieldconstraints';

	var isBlank = function(value) {
		return value ? value.toString().replace(/\s/g, '') === '' : true;
	};


	return Model.extend({

		initialize: function(options) {
			//this model is also used on a dashboard
			// so we don't need to fetch anything in that case
			// The only case we need to fetch constraints is in Report view,
			// and when new filter is added from report view
			if (options.doFetchConstraintsOnInit) {
				this.fetchConstraints();
			}
			this.listenTo(this, 'change', function() {
				this.set('isDirty', true, {
					silent: true
				});
			});
		},

		defaults: function() {
			return {
				values: [],
				possibleValues: [],
				isFetchingConstraints: false,
				isDirty: false
			};
		},

		http: http,

		validate: function() {
			if (!this.has('fieldObject')) {
				return 'Filter has no field';
			}

			if (VALID_OPERATORS.indexOf(this.get('operator')) === -1) {
				return 'Invalid operator: ' + this.get('operator');
			}

			if (!this.has('arity') && this.get('values').length === 0) {
				return 'requires at least one value';
			}

			var usableValues = this.get('values').slice(0, this.get('arity'));

			// ROLLINGDATERANGE has no arity
			if (usableValues.length < this.get('arity') && this.getOperator() !== 'ROLLINGDATERANGE') {
				return 'requires ' + this.get('arity') + ' values, ' + usableValues.length + ' found';
			}

			if (_.any(usableValues, _.isNull)) {
				return 'cannot be null';
			}

			// REVIEW: These checks don't belong here.
			// Perhaps operator should be an object. It could then validate whether
			// a given combination of type and values is valid. It could also report
			// whether it works against a given type, and what input control to use
			// each type. We could then replace filterTypes.js.
			//
			// op.identifier() // EQ, BETWEEN, etc
			// op.supportsType(type)
			// op.getInputControlForType(type)
			// op.validate(type, values)
			//
			// FieldFilterView would loop over the list of all operators and create
			// a drop down option for each one that supports the field type. When
			// the user selects on of the operators, it would pass the operator object
			// to FieldFilter and render the control supplied by the operator.


			if (this.type() === 'STR') {
				if (_.some(usableValues, isBlank)) {
					return 'cannot be empty';
				}
			}

			if (this.type() === 'INT' || this.type() === 'DEC' || this.type() === 'TIMESPAN' || this.type() === 'CURRENCY') {
				if (!_.all(usableValues, _.isNumber)) {
					return 'must be a number';
				}
			}

			if (this.getOperator() === 'ROLLINGDATERANGE') {
				if (!_.all(usableValues, _.isObject)) {
					return 'invalid value for ROLLINGDATERANGE';
				}
			} else {
				if (this.getOperator() === 'EQ' && usableValues.length === 1 && typeof usableValues[0] === 'undefined') {
					return 'must have a valid value';
				}
				if (_.any(usableValues, _.isObject)) {
					return 'invalid value';
				}
			}
		},

		setField: function(field) {
			this.set('fieldObject', field);
		},
		getField: function() {
			return this.get('fieldObject');
		},
		setOperator: function(operator) {
			this.set('operator', operator);
		},
		getOperator: function() {
			return this.get('operator');
		},
		setValue: function(position, value) {
			this.get('values')[position] = value;
			this.trigger('change');
		},
		initializeValue: function(position, value) {
			var values = this.get('values');
			if (values[position] === undefined) {
				values[position] = value;
			}
		},
		getValue: function(position) {
			return this.get('values')[position];
		},
		getValues: function() {
			return this.get('values');
		},
		setValues: function(values) {
			return this.set('values', values || []);
		},
		possibleValues: function() {
			return this.get('possibleValues');
		},
		getValuesAsJson: function() {
			return JSON.stringify(this.get('values'));
		},
		setValuesAsJson: function(str) {
			this.set('values', JSON.parse(str));
		},
		setArity: function(n) {
			this.set('arity', n);
		},
		clearArity: function() {
			this.unset('arity');
		},
		fieldId: function() {
			return this.get('fieldObject').id;
		},
		fieldName: function() {
			return this.get('fieldObject').displayName();
		},

		fieldQualifiedName: function() {
			return this.get('fieldObject').qualifiedName();
		},
		isCompound: function() {
			return false;
		},
		type: function() {
			return this.get('fieldObject').dataType();
		},
		enumeration: function() {
			if (_.isFunction(this.get('fieldObject').getEnumeration)) {
				return this.get('fieldObject').getEnumeration();
			}
			return null;
		},
		getDisplayFormat: function() {
			return this.get('fieldObject').getDisplayFormat();
		},
		remove: function() {
			if (this.collection && this.collection.remove) {
				this.collection.remove(this);
			}
		},

		isFetchingConstraints: function() {
			return this.get('isFetchingConstraints');
		},

		// TODO: This responsibility should belong to the field object and it should cache the result.
		fetchConstraints: function() {
			var self = this,
				type,
				displayFormat;

			if (this.get('fieldObject') && !this.get('fieldObject').get('funcArguments')) {
				type = this.get('fieldObject').get('type');
				displayFormat = this.get('fieldObject').get('displayFormat');

				// Exclude hardcoded constraints
				if (type !== 'DATETIME' && type !== 'TIMESPAN' && displayFormat !== 'time') {
					this.set('isFetchingConstraints', true, {
						silent: true
					});

					var postData = {
						fieldIds: [this.fieldId()],
						domainId: this.get('fieldObject').domainId()
					};

					return this.http.post(FIELD_CONSTRAINTS_SERVICE_URL, postData).then(function(data) {
						var match = _.findWhere(data, {
							fieldId: self.fieldId(),
							constraintType: 'ENUM'
						});
						if (match) {
							self.set('possibleValues', _.reject(match.constraint, function(c) {
								return c === null || c === undefined;
							}));
						}
						self.set('isFetchingConstraints', false, {
							silent: true
						});
						self.trigger('finishFetchingConstraints');
					});
				}
			}
		},

		isDirty: function() {
			return !!this.get('isDirty');
		},

		clean: function() {
			this.set('isDirty', false, {
				silent: true
			});
		},

		toJSON: function() {

			var valuesAsOperands = _.map(this.get('values'), function(value) {
				return {
					val: value
				};
			});

			var arity = this.get('arity');
			if (_.isNumber(arity)) {
				valuesAsOperands = valuesAsOperands.slice(0, arity);
			}

			var fieldIdAsOperand = {
				fieldId: this.fieldId()
			};

			// Set segmentId if it exists
			if (this.get('columnType') === 'SEGMENT') {
				fieldIdAsOperand = {
					segmentId: this.get('fieldObject').get('id')
				};
			}

			// Set function if it exists
			if (this.get('columnType') === 'FUNCTION') {
				fieldIdAsOperand = {
					function: this.get('fieldObject').get('id'),
					funcArguments: this.get('funcArguments')
				};
			}

			return {
				operator: this.get('operator'),
				operands: [fieldIdAsOperand].concat(valuesAsOperands)
			};
		},

		fromJSON: function(jsonObject, domain) {
			var self = this;
			if (!(jsonObject && jsonObject.operator && jsonObject.operands && jsonObject.operands.length && jsonObject.operands.length > 1)) {
				throw new Error('Invalid format of FieldFilter JSON object: ' + JSON.stringify(jsonObject));
			}

			//set operator
			this.setOperator(jsonObject.operator);

			//pull the field object from domain and create linkage
			var fieldId = jsonObject.operands[0].fieldId;

			var fieldObj = domain.dateFields().get(fieldId);

			if (domain.dateFields().length === 0) {
				return;
			}

			if (!fieldObj) {
				throw new Error('Could not find field id \'' + fieldId + '\' in the domain.');
			}
			this.set('fieldObject', fieldObj);

			//set arity and values
			var vals = jsonObject.operands.slice(1);
			this.setArity(vals.length);
			_.map(vals, function(o, index) {
				self.get('values')[index] = o.val;
			});
		},

		clone: function() {
			var attributes = _.clone(this.attributes);
			attributes.values = JSON.parse(JSON.stringify(this.attributes.values));
			return new this.constructor(attributes);
		}
	});

});

